export const RoundTypesOptions = [
  { label: "Pre Seed", value: "pre_seed" },
  { label: "Seed", value: "seed" },
  { label: "Series A", value: "series_a" },
  { label: "Series B", value: "series_b" },
  { label: "Series C and Beyond", value: "series_c" },
]
